function gettype(value) {
  switch (typeof value) {
    default:
      return false;

    case 'boolean':
    case 'number':
    case 'string':
      return typeof value;

    case 'object':
      return 'array';
  }
}

module.exports = gettype;



// WEBPACK FOOTER //
// ./src/libs/twig/gettype/index.js